import React, { useEffect, useState } from "react";
import "../Home/Home.css";
import { NavDropdown, Form } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { useLocation, useNavigate } from "react-router-dom";

const SearchContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const locationParam = params.get("location");
  const experience = params.get("experience");
  const skills = params.get("skills");
  const [searchFilter, setSearchFilter] = useState({
    skills: skills,
    location: locationParam,
    experience: experience,
  });

  const handleSearchInput = (e) => {
    const { name, value } = e.target;
    setSearchFilter((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleExperienceSelect = (value) => {
    setSearchFilter((prev) => ({
      ...prev,
      experience: value,
    }));
  };

  const handleSearchContainer = async (e) => {
    e.preventDefault();

    const queryParams = {};

    if (searchFilter.skills) queryParams.skills = searchFilter.skills;
    if (searchFilter.experience)
      queryParams.experience = searchFilter.experience;
    if (searchFilter.location) queryParams.location = searchFilter.location;

    const queryString = new URLSearchParams(queryParams).toString();

    navigate(`/user/find-job${queryString ? `?${queryString}` : ""}`);
  };

  return (
    <div className="search_container" id="search_container">
      <div className="search_content_container">
        <h1 className="search_heading">Find Your Dream Job Now</h1>
        <p className="Search_text">5 lakh+ jobs for you to explore</p>
        <div className="search_dropdown_content">
          <Form onSubmit={handleSearchContainer}>
            <div className="search_input_item">
              <CiSearch
                className="icon_search_new"
                style={{
                  fontSize: "24px",
                }}
              />
              <div className="enter_skill">
                <div className="search_contain_input">
                  <input
                    name="skills"
                    value={searchFilter.skills}
                    className="input_search"
                    onChange={handleSearchInput}
                    type="text"
                    placeholder="Enter skill / designations / companies"
                  />
                </div>
              </div>
              <div className="dropdown_year">
                <NavDropdown
                  id="hero_search_dropdown"
                  title={
                    <span className="nav-dropdowns-title">
                      {searchFilter.experience || "Select experience"}
                    </span>
                  }
                  className="items-hovers"
                  renderMenuOnMount={true}
                >
                  {[
                    { value: "Fresher", label: "Less than 1 Year" },
                    { value: "1 year", label: "1 Year" },
                    { value: "2 year", label: "2 Years" },
                    { value: "3 Year", label: "3 Years" },
                    { value: "4 Year", label: "4 Years" },
                    { value: "5+ Year", label: "5+ Years" },
                  ].map((item, index) => (
                    <NavDropdown.Item
                      key={index}
                      onClick={() => handleExperienceSelect(item.value)}
                      className="dropdown-item-hovers"
                      style={{ color: "black" }}
                    >
                      {item.value}
                      {item.label && (
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: "lighter",
                            color: "#333",
                            marginLeft: "4px",
                          }}
                        >
                          {item.label}
                        </span>
                      )}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              </div>
              <div className="d-flex search_contain_input">
                <input
                  type="text"
                  value={searchFilter.location}
                  name="location"
                  placeholder="Enter location"
                  className="input_search"
                  onChange={handleSearchInput}
                />
                <button type="submit" className="input_search_button">
                  Search
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default SearchContainer;
